var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7475",
    "data-name": "Group 7475",
    transform: "translate(-1676 -306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3127",
    "data-name": "Ellipse 3127",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1676 306)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(1686 316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6622",
    "data-name": "Rectangle 6622",
    width: 4,
    height: 16,
    rx: 1.98,
    transform: "translate(6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6623",
    "data-name": "Rectangle 6623",
    width: 16,
    height: 4,
    rx: 1.98,
    transform: "translate(0 6)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeviceIcon);
export default __webpack_public_path__ + "static/media/AddDeviceIcon.cc60682b8ae94582282be54c01d40bb4.svg";
export { ForwardRef as ReactComponent };